export const isFulfilled = <T>(
  input: PromiseSettledResult<T>,
): input is PromiseFulfilledResult<T> => input.status === 'fulfilled';

export type RelationReference = {
  index: string;
  relation: string | string[];
  data?: any;
};
